import { SITE, footerNav } from "../data";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-emotion-laugh-line text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-casual text-xl text-background-50">{SITE.brand}</span>
            </div>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-md">
              {SITE.intro}
            </p>
            <p className="mt-4 text-xs text-secondary-300">
              {SITE.season} · 每年两季，只黑自己，不黑别人。
            </p>
          </div>

          {footerNav.map((group) => (
            <nav key={group.title} aria-label={group.title}>
              <h3 className="text-sm font-heading font-bold text-background-50 mb-4">{group.title}</h3>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            内容由参赛者本人分享，赛事仅作非商业展映。© {new Date().getFullYear()} {SITE.brand}
          </p>
          <div className="flex items-center gap-3">
            <a href={`mailto:${SITE.email}`} className="text-xs text-background-300 hover:text-accent-400 transition-colors">
              {SITE.email}
            </a>
            <span className="w-px h-3 bg-secondary-700" />
            <a href="#contact" className="text-xs text-background-300 hover:text-accent-400 transition-colors">
              联系方式
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}